import React, {useEffect, useState} from 'react'
import { makeStyles, withStyles  } from '@material-ui/core';
import { AppBar, Toolbar, Container, Typography, Paper, Checkbox, FormControlLabel,FormGroup, Grid, Button , Slide, FormControl, RadioGroup, FormLabel, Radio, Fade } from '@material-ui/core';
import ArrowRightAltIcon from '@material-ui/icons/ArrowRightAlt';
import zennya_health_logo from '../../assets/zennya-health-logo-teal.png';
import axios from "axios";
import { useParams, useLocation } from  'react-router-dom'
import screeningImage from '../../assets/Flat.png'

function useQuery() {
    return new URLSearchParams(useLocation().search);
  }

const useStyles = makeStyles(theme => ({
    root: {
      color: 'white',
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      // padding: theme.spacing(2)
    },
    logo:{
        height: 80,
        padding:10
    },
    AppBar:{
        backgroundColor:'#74BACD'
    },
    container:{
        marginTop:120,
        backgroundColor:'white',
        color: '#000',
        display:'flex',
        justifyContent:'center',
        alignItems:'center'
    },
    questionaire:{
        minHeight:'50vh',
        width:'100%',
        maxWidth:700,
        padding:'3rem',
        borderRadius:20,
        display:'flex',
        flexDirection:'column'
    },
    title:{
        marginBottom: 30,
    },
    paragraphs:{
        marginTop: 20,
        marginBottom:10,
        fontSize:15,
        lineHeight:1.5
    }
  }));
export default function ExternalHealthScreening(){
    const classes = useStyles()
    const [ data, setData ] = useState(null)
    const [ userData, setUserData ] = useState({
        user:null,
        token:null
    })
    const [ termsAgreement, setTermsAgreement ] = useState({
        value:null
    })
    const [ slideDirection, setSlideDirection ] = useState('left')
    const [ assessment, setAssessment ] = useState(null)
    const [ start, setStart ]= useState(false)
    const [ loading, setLoading ] = useState(true)
    const [ currentPage, setCurrentPage ] = useState(null)
    const [ currentAnswer, setCurrentAnswer ] = useState({questions:[]})
    const [ questions, setQuestions ] = useState([])
    const API_URL = process.env.REACT_APP_WEB_ADMIN_URL
    let query = useQuery();

    const TealCheckbox = withStyles({
        root: {
          color:'#74BACD',
          '&$checked': {
            color:'#74BACD',
          }
        },
        checked: {},
      })((props) => <Checkbox color="default" {...props} />);

    const TealButton = withStyles((theme) => ({
    root: {
        color: '#fff',
        backgroundColor: '#74BACD',
        borderRadius:20,
        marginLeft:10,
        width:'100%',
        '&:hover': {
          backgroundColor:"#fff",
          color:"#74BACD"
        },
    },
    }))(Button);
    
    const DarkGray = withStyles((theme)=>({
        root: {
            color: '#fff',
            backgroundColor: '#4F4F4F',
            borderRadius:20,
            marginRight:10,
            width:'100%',
            '&:hover': {
              backgroundColor:"#fff",
              color:"#4F4F4F"
            },
        },
    }))(Button)
    
    const TealRadio = withStyles({
        root: {
            color:'#74BACD',
            '&$selected': {
              color:'#74BACD',
            }
          },
    })(props=><Radio color="default" {...props} />)

    const fetchScreening = async() => {
        if(userData.user===null) return

        await axios.get(`${API_URL}/api/2/clients/${userData.user}/corporate?include_bookings=false`,{ headers: {
            "X-Auth-Token": userData.token,
            "content-type": "application/json"
        }}).then(result=>{
            setData({...result.data})
        }).catch((error)=>{
            console.log("Failed: ",error)
        }).finally(()=>{
            setLoading(false)
        })
    }

    const fetchQuestions = async() => {
        if(currentPage<questions.length-1){
            return setCurrentPage(currentPage+1)
        }
        return submitQuestions()
    }

    const submitQuestions = async() => {
        if(currentPage===questions.length-1){
            await axios.post(`${API_URL}/api/1/pre_assessments/${assessment.assessment.id}/evaluate`,currentAnswer,{ headers: {
                "X-Auth-Token": userData.token,
                "content-type": "application/json"
            }}).then(result=>{
                setAssessment({...assessment, evaluation:result.data, status: result.data.status})
                setCurrentPage(currentPage+1)
                
            }).catch((error)=>{
                console.log("Failed: ",error)
            })
        }
    }

    const fetchAssessment= async() => {
        if(data===null) return
        const params = {
            user: userData.user,
            type: data.settings.pre_assessment.type_id
        }
        await axios.post(`${API_URL}/api/1/pre_assessments/start`,params,{ headers: {
            "X-Auth-Token": userData.token,
            "content-type": "application/json"
        }}).then((result)=>{
                setAssessment({...result.data, status: result.data.evaluation.status})
        }).catch((error)=>{
            console.log("Failed: ",error)
        })

    }

    const fetchToken = async() => {
        const token = query.get("token")
        const parameter = {
            login_token: token,
            device_id:"web"
        }
        await axios.post(`${API_URL}/api/1/clients/login_by_token`,parameter).then((result)=>{
            setUserData({
                token: result.data.token, user: result.data.client.id
            })
        }).catch(()=>{
            setLoading(false)
        })
    }

    useEffect(()=>{
        fetchToken()
    },[])
    
    useEffect(()=>{
        fetchScreening()
    },[userData])
    
    useEffect(()=>{
        fetchAssessment()
    },[data])


    useEffect(()=>{
        if(assessment!==null){
            if(assessment.status==='PENDING'){
                if(assessment.evaluation){
                    const unique = assessment.evaluation.questions.map(e => e['key'])
                    .map((e, i, final) => final.indexOf(e) === i && i)
                    .filter(obj=> assessment.evaluation.questions[obj])
                    .map(e => assessment.evaluation.questions[e]);
                    setQuestions([...questions,...unique])
                }
            }
        }
    },[assessment])

    const handleChange = event => {
        if(event.target.name==='TermsAgreement'){
            return setTermsAgreement({...termsAgreement, value:event.target.checked})
        }
        // this updates the form
        
        let newQuestions = questions.map((question,index)=>{
            if(currentPage===index){
                if(event.target.value==='none'){
                    question.none_answer.selected=!question.none_answer.selected
                }
                const newAnswers = question.answers.map(answer=>{
                    if(question.type==='SINGLE_SELECTION'){
                        answer.selected=false
                    }

                                            
                    if(answer.key===event.target.value){
                        // console.log('answer.key===event.target.value >> ', answer.key===event.target.value)
                        // console.log('answer.key=== ', answer.key)
                        // console.log('event.target.value >> ', event.target.value)
                        updateCurrentAnswers(question.type, question.key, answer.key)
                        answer.selected = !answer.selected
                        
                        if(question.none_answer!==null){
                            question.none_answer.selected=false
                        }
                        return answer
                    }
                    
                    if(event.target.value==='none'){
                        updateCurrentAnswers(question.type, question.key, "none")
                        answer.selected=false 
                        return answer
                    }
                    return answer
                })
                question.answers = newAnswers
                
            }
            return question
        })
        setQuestions([...newQuestions])
    }

    const handleProceed = (actions) => {
        if(actions==='terms'){
            setCurrentPage(0)
        }

        if(actions==='next'|| actions==='submit'){
            fetchQuestions()
            setSlideDirection("left")
        }

        if(actions==='back'){
            setCurrentPage(currentPage-1)
            setSlideDirection("right")
        }
    }

    const renderDone = () => {
        if(assessment===null) return

        return <>
        {/* <Paper className={classes.questionaire} align="left" elevation={15} style={{boxShadow:"0px 15px 40px -7px rgba(174,174,174,1)",WebkitBoxShadow:"0px 15px 40px -7px rgba(174,174,174,1)",MozBoxShadow:"0px 15px 40px -7px rgba(174,174,174,1)",display: 'flex', flexDirection:'column', justifyContent:'space-between', alignItems:'center'}} align="center">
                    <Typography variant="h2" align="center">{assessment.evaluation.result.content.title}</Typography> */}
                    {assessment.evaluation.result.content.map(c=>{
                        return <>
                        <img src={c.image_url} style={{width: '100%', maxWidth: 500, objectFit:'contain'}}/>
                        <Typography align="center">{c.description}</Typography>    
                        </>
                    })}
                    {/* <Typography variant="h3" align="center">{assessment.evaluation.result.content.label}</Typography>
                    <Typography variant="h5" align="center">{assessment.evaluation.result.content.description}</Typography>
                </Paper> */}
                </>
    }

    const renderOptions = (key, options, question, type, questions) => {
        // console.log("Options >> ", options)
        if(type==="MULTI_SELECTION"){
            return <FormControl required component="fieldset" className={classes.formControl}>
            <FormLabel component="legend">{question}</FormLabel>
            <FormGroup>
              {options.map((option)=>{
                  return <FormControlLabel
                control={<TealCheckbox onChange={handleChange} value={option.key} checked={option.selected} />}
                label={option.label}
              />})}
              { questions.none_answer ?  <FormControlLabel
                control={<TealCheckbox onChange={handleChange} value={questions.none_answer.key} checked={questions.none_answer.selected} />}
                label={ questions.none_answer.label }
              />: null }
            </FormGroup>
          </FormControl>
        }

        if(type==="SINGLE_SELECTION"){
            const selectedOption = options.find(option=>option.selected===true)
            
            return <FormControl component="fieldset">
            <FormLabel component="legend">{question}</FormLabel>
            <RadioGroup aria-label="gender" name={key} value={selectedOption?selectedOption.key:''} onChange={handleChange}>
                {options.map((option,idx)=>{
                    return <FormControlLabel value={option.key} control={<TealRadio />} label={option.label} />
                })}
            </RadioGroup>
          </FormControl>
        }

        if(type==="checkbox"){

        }
    }
    

    const updateCurrentAnswers = (type,questionKey, answerKey) =>{
        // this updates the form data
        let index = currentAnswer.questions.findIndex(question => question.key===questionKey)
        let questionToUpdate=null
        if(index<0){
            questionToUpdate={key: questionKey, answers:[]}
        }else{
            questionToUpdate = currentAnswer.questions[index]
        }

        if(type==='SINGLE_SELECTION'){
            questionToUpdate.answers=[{key:answerKey}]
        }
        if(type==='MULTI_SELECTION'){
            
            if(answerKey==='none'){
                questionToUpdate.answers=[{key:'none'}]
                
                let newData = currentAnswer
                if(index<0){
                    newData.questions[currentPage] = questionToUpdate
                }else{
                    newData.questions[index<0?0:index] = questionToUpdate
                }
                return setCurrentAnswer({...newData})
            }

            let existingAnswers = questionToUpdate.answers

            if(existingAnswers.length>0 &&existingAnswers[0].key==='none'){
                existingAnswers=[]
            }
            
            let existFlag = false
            let newMultiSelectValues = existingAnswers.map((answer)=>{
                if(answer.key===answerKey){
                    // do not add the answerkey to the list of answers
                    return existFlag = true    
                }
                return answer
            })
            // if exist flag is false, add the key
            if(!existFlag){
                newMultiSelectValues=[...newMultiSelectValues,{key:answerKey}]
            }
            
            const unique = newMultiSelectValues.map(e => e['key'])
                .map((e, i, final) => final.indexOf(e) === i && i)
                .filter(obj=> newMultiSelectValues[obj])
                .map(e =>newMultiSelectValues[e]);
            questionToUpdate.answers=[...unique]
        }
        
        let newData = currentAnswer
        if(index<0){
            newData.questions[currentPage] = questionToUpdate
        }else{
            newData.questions[index<0?0:index] = questionToUpdate
        }
        setCurrentAnswer({...newData})
    }

    const renderAgreement = () => {
        if(!start) return

        if( assessment.evaluation?.status==='DONE'){
            return <>{renderDone()}</>
        }

        if(assessment.status==='DONE'){
            return <>{renderDone()}</>
        }

        if(assessment.evaluation.need_terms_of_service && currentPage===null){
            return(
                <Paper className={classes.questionaire} align="left" elevation={15} style={{boxShadow:"0px 15px 40px -7px rgba(174,174,174,1)",WebkitBoxShadow:"0px 15px 40px -7px rgba(174,174,174,1)",MozBoxShadow:"0px 15px 40px -7px rgba(174,174,174,1)"}}>
                    <Typography variant="h6" className={classes.title}>{`Terms of Agreement`}</Typography>
                    <div style={{overflow:'auto', height:'70%'}}>
                        <div className={classes.paragraphs}>{assessment.assessment.terms_intro.details}</div>
                    </div>
                    <Grid container style={{flexGrow:1, alignItems:'flex-end'}}>
                        <Grid item xs={8}>
                            <FormControlLabel
                                control={<TealCheckbox checked={termsAgreement.value} onChange={handleChange}
                                fontSize="small" name="TermsAgreement" />}
                                label={assessment.assessment.terms_intro.accept_label} className={classes.paragraphs}
                            />
                        </Grid>
                        <Grid item xs={4} align="right">
                            {termsAgreement.value?
                            <TealButton variant="contained" color="primary" onClick={()=>handleProceed('terms')} endIcon={<ArrowRightAltIcon/>}>
                                Proceed
                            </TealButton>:null}
                        </Grid>
                    </Grid>
                </Paper>
            )
        }
        if((!assessment.evaluation.need_terms_of_service)|| (currentPage>=0 && currentPage<questions.length)){
            return <>{renderQuestions()}</>
        }
        if(currentPage>=0 && currentPage<questions.length){
            return <>{renderQuestions()}</>
        }
    }

    const renderQuestions = () => {
        return <>{questions.map((question,index)=>{
            if(currentPage===index){
                return <Slide in={true} direction={slideDirection}><Paper className={classes.questionaire} align="left" elevation={15} key={index}>
                    <Typography variant="h6" className={classes.title}>{question.title||'COVID-19 Vaccination Event Health Screening'}</Typography>
                    <div style={{overflow:'auto', height:'70%'}}>
                        {renderOptions(question.key, question.answers, question.label, question.type, question)}
                        
                    </div>
                    <Grid container style={{flexGrow:1,justifyContent:'space-between', alignItems:'flex-end'}}>
                    <Grid item xs={6} sm={4} align="right">
                            {currentPage>0 ?
                            <DarkGray variant="contained" color="primary" onClick={()=>handleProceed('back')}>
                                Back
                            </DarkGray>:null}
                        </Grid>
                        <Grid item xs={6} sm={4} align="right">
                            { currentPage<questions.length-1 && currentAnswer.questions[currentPage]!==undefined?
                            <TealButton variant="contained" color="primary" onClick={()=>handleProceed('next')} endIcon={<ArrowRightAltIcon/>}>
                                Proceed
                            </TealButton>:
                            currentAnswer.questions.length>0 && currentAnswer.questions[currentPage]!==undefined?<TealButton variant="contained" color="primary" onClick={()=>handleProceed('next')} disabled={question.answer===null?true:false}>
                                Submit
                            </TealButton>:null}
                        </Grid>
                    </Grid>
                </Paper>
                </Slide>
            }
        })}
        </>
    }

    const startAssessment = () =>{
        return setStart(true)
    }

    const renderSpiel = () => {
        // render here if allready taken spiel
        if(assessment!==null){
            if(assessment.evaluation.status==='DONE'){
                return renderFinishSpiel()
            }
        return <Paper className={classes.questionaire} align="left" elevation={15} style={{boxShadow:"0px 15px 40px -7px rgba(174,174,174,1)",WebkitBoxShadow:"0px 15px 40px -7px rgba(174,174,174,1)",MozBoxShadow:"0px 15px 40px -7px rgba(174,174,174,1)",display: 'flex', flexDirection:'column', justifyContent:'space-between', alignItems:'center'}} align="center">
            <Typography variant="h2" align="center">{`Hi ${data.settings.employee_full_name}`}</Typography>
            <img src={screeningImage} style={{width: 120}}/>
            <Typography align="center">{assessment.assessment.intro.details}</Typography>
            <TealButton onClick={()=>{startAssessment()}}>{`Let's get started`}</TealButton>
        </Paper>
        }

        return renderAgreement()
    }

    const renderLoadingIcon = () => {
        return <h1>Loading</h1>
    }

    const renderFinishSpiel = () => {
        return <Paper className={classes.questionaire} align="center" elevation={15} style={{boxShadow:"0px 15px 40px -7px rgba(174,174,174,1)",WebkitBoxShadow:"0px 15px 40px -7px rgba(174,174,174,1)",MozBoxShadow:"0px 15px 40px -7px rgba(174,174,174,1)"}}>

                <Typography variant="h1" style={{marginBottom:50}}>{assessment.evaluation.result.title}</Typography>
                <Typography variant="subtitle1">{assessment.evaluation.result.description}</Typography>
                {assessment.evaluation.result.content.map(c=>{
                    return <>
                    <img src={c.image_url} style={{width: '100%', maxWidth: 500, objectFit:'contain', marginLeft:'auto', marginRight:'auto', marginTop: 50}}/>
                    <Typography align="center">{c.description}</Typography>    
                    </>
                })}
            </Paper>
        }

    return (
        <div className={ classes.root }>
        <AppBar
        position="fixed"
        className={classes.AppBar}>
            <Toolbar>
                <img 
                    alt="zennya health corp"
                    className={classes.logo}
                    src={zennya_health_logo}
                />
            </Toolbar>
        </AppBar>
        <Container className={classes.container}>
            {loading?renderLoadingIcon(): data!==null ? data.settings.show_self_assessment ?  start ?  renderAgreement(): renderSpiel() : renderFinishSpiel(): <div><Typography variant="h1" align="center" style={{marginBottom:20}}>Sorry!</Typography>
            <Typography variant="subtitle1" align="center">Your data seems to be missing.</Typography></div>}
        </Container>
        </div>
    );
}